"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderPreviewImage = exports.PreviewImage = void 0;
var app_1 = require("app");
var React = require("react");
var webexUI_1 = require("webexUI");
var PreviewBox_1 = require("../PreviewBox/PreviewBox");
var PreviewImage = function (_a) {
    var videoUrl = _a.videoUrl, playButtonAriaLabel = _a.playButtonAriaLabel, popupAriaLabel = _a.popupAriaLabel, closeButtonAriaLabel = _a.closeButtonAriaLabel;
    var videoImgUrl = React.useMemo(function () { return webexUI_1.VideoService.getPreviewImage(videoUrl); }, [videoUrl]);
    var handleOnClick = React.useCallback(function () {
        if (webexUI_1.VideoService.checkIsValidVideo(videoUrl)) {
            PreviewBox_1.renderPreviewBox(videoUrl, popupAriaLabel, closeButtonAriaLabel);
        }
    }, [closeButtonAriaLabel, popupAriaLabel, videoUrl]);
    var handleOnKeyPress = React.useCallback(function (event) {
        if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
            handleOnClick();
        }
    }, [handleOnClick]);
    return (React.createElement("div", { onClick: handleOnClick, onKeyPress: handleOnKeyPress, className: videoUrl ? 'video-preview-wrapper' : '' },
        React.createElement("div", { className: "video-preview-image", style: { backgroundImage: "url(" + videoImgUrl + ")" } }),
        React.createElement("button", { className: "cta cta--with-icon cta--alpha cta--play-video", "aria-label": playButtonAriaLabel },
            React.createElement("span", { className: "cta-content" },
                React.createElement("span", { className: "icon icon-play" })))));
};
exports.PreviewImage = PreviewImage;
var RenderPreviewImage = function (videoUrl, el, playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel) {
    app_1.reactDOMRender(React.createElement(exports.PreviewImage, { videoUrl: videoUrl, playButtonAriaLabel: playButtonAriaLabel, popupAriaLabel: popupAriaLabel, closeButtonAriaLabel: closeButtonAriaLabel }), el);
};
exports.RenderPreviewImage = RenderPreviewImage;
